import React from "react";
import { motion } from "framer-motion";
import TestimonialsSlider from "./Layout/TestimonialSlider";
import { fadeIn } from "../Variants";
import Head from "./Layout/Head";

const Testimonials = () => {
  return (
    <div className="h-full bg-primary/30 py-32 text-center">
      <Head title="Testimonials | Dev Forge Pro" />
      <div className="container mx-auto h-full flex flex-col justify-center">
        <motion.h2
          variants={fadeIn("up", 0.2)}
          initial="hidden"
          animate="show"
          exit="hidden"
          className="h2 mb-8 xl:mb-0"
        >
          What Clients <span className="text-accent">Say.</span>
        </motion.h2>
        <motion.div
          variants={fadeIn("up", 0.4)}
          initial="hidden"
          animate="show"
          exit="hidden"
          className=""
        >
          <TestimonialsSlider />
        </motion.div>
      </div>
    </div>
  );
};

export default Testimonials;
